(function($){
    'use strict';

    var $filter = $('.filter'),
        $title = $filter.find('.filter__title'),
        $titleButton = $title.find('a'),
        $dateFields = $('.js-date-field');

        $titleButton.click(function(event){
            event.preventDefault();
            
            if(!$filter.hasClass('active')){
                $filter.addClass('active');
            }else {
                $filter.removeClass('active');
            }
        });

        if($dateFields.length){
            $dateFields.each(function(){

                var $cur = $(this);
                $cur.focus(function(){
                    $(this).parent().removeClass('error');
                });

                $cur.inputmask("dd/mm/yyyy", {
                    placeholder: 'DD/MM/YYYY',
                    oncomplete: function(){
                        if($(this).hasClass('js-date-field-to')){
                            $(this).parent().addClass('valid');
                        }

                        if($(this).data('fieldname')) {
                            var fieldName  = $(this).data('fieldname');
                            
                            var dateEntered = $(this).val();
                            var dateSplit = dateEntered.split('/');
                            var dateObj = new Date(dateSplit[1] + '/' + dateSplit[0] + '/' + dateSplit[2]);

                            if($(this).hasClass('js-decision-date')) {
                                $("input[name='"+fieldName+"']").val(Math.round(dateObj.getTime()) / 1000);
                            } else {
                                $("input[name='"+fieldName+"']").val(Math.round(dateObj.getTime()));
                            }   
                        }

                    },
                    onincomplete: function(){
                        
                        $(this).parent().removeClass('valid');

                        if($(this).val().length){
                            $(this).parent().addClass('error');
                        }

                        if($(this).data('fieldname')) {
                            var fieldName  = $(this).data('fieldname');

                            $("input[name='"+fieldName+"']").val('');
                        }
                    }
                });
            });
        }

    $('.js-set-hidden').on('click', function(e){
        e.preventDefault();
        

        var fieldName  = $(this).data('fieldname'),
            fieldValue = $(this).data('value');

        if(fieldValue =='' || fieldValue == null) {
            if($("input[name='clive']")) {
                $("input[name='clive']").val('');
            }
        }

        $("input[name='"+fieldName+"']").val(fieldValue);

        $('.js-search').submit();
    });

    /////Showing 'Clear Filters' link if queryString present.

    var url = window.location.href;

    var getQueryString = function (field, url) {
        var href = url ? url : window.location.href;
        var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
        var string = reg.exec(href);
        return string ? string[1] : null;
    }

    var typeType = getQueryString('f.type%7Ctype', url);
    
    var subjectType = getQueryString('f.subject%7Csubject', url);
    var decisionType = getQueryString('f.Type%7Cdecisiontype', url);

    function showFilters($selector, value) {
        if ((value != null) && (value).length != 0) {
            $($selector).addClass('active');
        } else {
            $($selector).removeClass('active');
        }
    }


    showFilters('.filter__clear-btn > a[data-fieldname="f.Type|decisiontype"]', decisionType);

    showFilters('.filter__clear-btn > a[data-fieldname="f.subject|subject"]', subjectType);

    showFilters('.filter__clear-btn > a[data-fieldname="f.type|type"]', typeType);

}(jQuery));